import { EyeOutlined } from '@ant-design/icons'
import { Button, Space, Table, Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'
import { ClientDevice } from '@/types'
import { DeviceDetail } from '@/types/apis/clientDevice/GetOneClientDeviceResponse'
import { formatHour, formatYMD } from '@/utils/date'

type Props = {
  dataSource: ClientDevice[]
  loading: boolean
}

const ClientsTable = ({ dataSource, loading }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const columns = [
    {
      title: t('components.pages.clients.table.id'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('components.pages.clients.table.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('components.pages.clients.table.lastPingAt'),
      dataIndex: 'lastPingAt',
      key: 'lastPingAt',
      render: (text: string, record: ClientDevice) => (
        <div>{`${formatYMD(record.lastPingAt)} ${formatHour(record.lastPingAt)}`}</div>
      ),
    },
    {
      title: t('components.pages.clients.table.isOffline'),
      dataIndex: 'status',
      key: 'status',
      render: (text: string, record: ClientDevice) => (
        <Tag color={record.isOffline ? 'red' : 'green'}>
          {record.isOffline ? t('components.pages.clients.table.offline') : t('components.pages.clients.table.online')}
        </Tag>
      ),
    },
    {
      align: 'center' as const,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      render: (text: string, record: ClientDevice) => (
        <Space size="middle">
          <Button onClick={() => goToDeviceDetailPage(record.id)} type="default" size="small">
            <EyeOutlined />
            {t('components.pages.clients.table.detailDevice')}
          </Button>
        </Space>
      ),
    },
  ]

  const goToDeviceDetailPage = (id: DeviceDetail['id']) => {
    navigate(`${routes.clients.path}/${id}`)
  }

  return <Table rowKey="id" dataSource={dataSource} columns={columns} loading={loading} pagination={false} />
}
ClientsTable.displayName = 'ClientsTable'
export default ClientsTable
